module.exports = __webpack_public_path__ + "img/duplicate.b9c76e32.svg";